// extracted by mini-css-extract-plugin
export var bodySections = "_a9-8";
export var gray = "_a9-7";
export var green = "_a9-4";
export var iconContainer = "_a9-9";
export var iconWidgetContainer = "_a9-1";
export var phoneIcon = "_a9-2";
export var red = "_a9-5";
export var statusDot = "_a9-3";
export var widgetContainer = "_a9-0";
export var yellow = "_a9-6";